import * as React from 'react'
import { lazy } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { ThemeProvider } from '@netapp/bxp-design-system-react'
import { AppContext } from './context/AppContext'
import { Userpilot } from 'userpilot'

const Home = lazy(async () => await import('./components/features/Dashboard/Dashboard'))
const NoAccessPage = lazy(async () => await import('./components/features/NoAccessPage/NoAccessPage'))

const Loading = lazy(async () => await import('./components/commons/loader/loader'))

const logUserpilot = (eventName: string, payload?: Record<string, any>): void => { }

const Routers = (): any => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const queryString = queryParams.toString()
  const { readCMTheme, userInfo }: any = React.useContext(AppContext)

  React.useEffect(() => {
    if (userInfo?.id != null) {
      logUserpilot('reload:start', {
        userId: userInfo.id,
        pathname: location.pathname,
        search: location.search,
      })
      Userpilot.reload()
      logUserpilot('reload:done', {
        userId: userInfo.id,
        pathname: location.pathname,
      })
    } else {
      logUserpilot('reload:skipped', {
        pathname: location.pathname,
        search: location.search,
      })
    }
  }, [location, userInfo?.id])

  return (
    <React.Suspense fallback={<Loading />}>
      <ThemeProvider theme={readCMTheme()} isRoot={true}>
        <Routes>
          <Route path='*' element={<Navigate to='/addNssAccount' />} />
          <Route path='/' element={<Navigate to={`/dashboard?${queryString}`} />} />
          <Route path='/dashboard' element={<Home />} />
          <Route path='/addNssAccount' element={<NoAccessPage />} />
        </Routes>
      </ThemeProvider>
    </React.Suspense>
  )
}

export default Routers
